module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "ancho"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('planes-disponibles')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posicionar-texto"
  }, [_c('h2', [_vm._v("El mejor Plan para tu negocio")]), _vm._v(" "), _c('h3', [_vm._v("Elige la opción que mejor se adapte a tus necesidades")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3062ba00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PlanesView.vue
// module id = 643
// module chunks = 1